//import { environment } from "projects/eacatfront/src/environments/environment";
import { environment } from "projects/eacatfront/src/environments/environment";
import { EntityBase } from "../entity/entity.model";
import { UserEntityProfileType } from "../user/user-entity-profile-type.model";
import { UserEntity, UserEntityBase } from "../user/user-entity.model";
import { UserAppManagerBase } from "../user/user-app-manager.model";
import { UserBase } from "../user/user.model";
import { AuthorityBase } from "./authority.model";
import { LocalStorageKeys } from "../local-storage-keys.model";

export class ConfigBase {

    serverAddress: string = environment.serverAddress
    mwfAddress: string = environment.mwfAddress
    fbAddress: string = environment.fbAdress

    appletSignerServerAddress!: string

    entityHeader:string ="";

    connectedEntityDetail!: { userEntity: UserEntity, entity: EntityBase }
    connectedUser: UserBase = new UserBase()
    authorities: AuthorityBase[] = []
    entities: { userEntity: UserEntity, entity: EntityBase }[] = []

    managerApp : UserAppManagerBase[] = []

    public isEmpty(): boolean {
        return this.appletSignerServerAddress == null
    }

    public getEntityHeader():string{
        return this.entityHeader
    }

    static fromConfig(config: Config): ConfigBase {
        let current = new ConfigBase();
        Object.assign(current, config)

        current.managerApp = []
        if (config.managerApp && Array.isArray(config.managerApp)) {
            config.managerApp.forEach(ap => {
                current.managerApp.push(UserAppManagerBase.fromUserAppManager(ap))
            })
        }

        current.connectedEntityDetail = {
            userEntity: UserEntityBase.fromUserEntity(config.connectedEntityDetail.userEntity),
            entity: EntityBase.fromEntity(config.connectedEntityDetail.entity)
        }

        current.connectedUser = UserBase.fromUser(config.connectedUser)
        current.authorities = []
        config.authorities.forEach(authority => {
            current.authorities.push(AuthorityBase.fromAuthority(authority))
        })

        current.entities = []
        if (config.entities) {
            config.entities.forEach(e => {
                current.entities.push({ userEntity: UserEntityBase.fromUserEntity(e.userEntity), entity: EntityBase.fromEntity(e.entity) })
            })
        }

        current.entities = current.entities.sort((a: { userEntity: UserEntity, entity: EntityBase }, b: { userEntity: UserEntity, entity: EntityBase }): number => {
            if (a.entity.entityInfo.name > b.entity.entityInfo.name) {
                return 1
            }
            if (a.entity.entityInfo.name < b.entity.entityInfo.name) {
                return -1
            }

            return 0;
        })

        current.reOrderEntities()

        return current;
    }

    putEntityAsRecent(entityId: number) {
        let recentEntities: number[] = []
        let data = <string>localStorage.getItem(LocalStorageKeys.RecentEntities)
        if (data != null && "" != data) {
            recentEntities = JSON.parse(data)           
        }
        

        recentEntities = recentEntities.filter(p => p != entityId)
        recentEntities = [entityId].concat(recentEntities)


        if (recentEntities.length > 5) {
            recentEntities.pop()
        }
        localStorage.setItem(LocalStorageKeys.RecentEntities, JSON.stringify(recentEntities))

    }



    public reOrderEntities() {
        let recentEntitiesId: number[] = []
        let data = <string>localStorage.getItem(LocalStorageKeys.RecentEntities)
        if (data != null && "" != data) {
            recentEntitiesId = JSON.parse(data)
        }

        if (recentEntitiesId.length == 0) {
            return
        }
        let entityOrdered = this.entities.map(p => {
            let data: { entity: { userEntity: UserEntity, entity: EntityBase }, order: number } = {
                entity: p,
                order: 999
            }

            return data;
        })
        recentEntitiesId.forEach((e, i) => {
            let ent = entityOrdered.filter(p => p.entity.entity.id == e)
            if (ent.length == 0) {
                return
            }
            ent[0].order = i
        })

        entityOrdered= entityOrdered.sort((a,b)=>{
            if (a.order>b.order){
                return 1
            }

            if (a.order==b.order){
                return 0
            }

            return -1
        })

        this.entities = []
        entityOrdered.forEach(p => this.entities.push(p.entity))

    }

    hasAdminProfile(): boolean {
        return this.authorities.filter(p => p.authority == UserEntityProfileType.ADMIN).length > 0
    }

    hasAocManagerProfile(): boolean {
        return this.authorities.filter(p => p.authority == UserEntityProfileType.AOC_MANAGER).length > 0
    }

    hasBatchProfile(): boolean {
        return this.authorities.filter(p => p.authority == UserEntityProfileType.BATCH_MANAGER).length > 0
    }

    hasSupportProfile(): boolean {
        return this.authorities.filter(p => p.authority == UserEntityProfileType.SUPPORT).length > 0
    }

    hasServiceManagerProfile(): boolean {
        return this.authorities.filter(p => p.authority == UserEntityProfileType.SERVICE_MANAGER).length > 0
    }

    hasEnsManagerProfile(): boolean {
        return this.authorities.filter(p => p.authority == UserEntityProfileType.ENS_MANAGER).length > 0
    }

    hasManagerApps(): boolean {
        return this.authorities.filter(p => p.authority == UserEntityProfileType.APP_SPEC_MANAGER).length > 0
    }

    hasSignerProfile(): boolean {
        return this.authorities.filter(p => p.authority == UserEntityProfileType.SIGNER).length > 0
    }

    hasUserProfile(): boolean {
        return this.authorities.filter(p => p.authority == UserEntityProfileType.USER).length > 0
    }


    // Don't remove, use it when u need to disable content on PRO //
    disabledForProductionRelease(canAdmin: boolean): boolean {
        if (canAdmin == true) {
            return this.isProduction() && !this.hasAdminProfile();
        }
        return this.isProduction();
    }

    isProduction(): boolean {
        return window.location.hostname == "eacat3-cl.aoc.cat";
    }

    getFBAddress() {
        const url = new URL(window.location.toString())

        let theUrl = url.origin + '/fbst/form-builder'
        if (url.origin.startsWith('http://')) {
            theUrl = this.fbAddress
        }
        return theUrl
    }


}

export interface Config extends ConfigBase {

}